module.exports = __webpack_public_path__ + "img/doricmor_logo_3.fcd7adf3.jpg";